import { useRouter } from "next/router";
import { useCallback } from "react";

import { useAuthUserUiState } from "@/states/auth/selectors";

const excludeRoutes = [
  "/400",
  "/404",
  "/500",
  "/login",
  "/logout",
  "/password-reset",
  "/forgot-password",
  "/register",
];

export function useUnauthenticatedHandler() {
  const router = useRouter();
  const authUser = useAuthUserUiState();

  return useCallback(async () => {
    if (authUser.status !== "NotLoggedIn") {
      return;
    }

    if (excludeRoutes.includes(router.route)) {
      return;
    }

    await router.push(`/login?redirect=${router.asPath}`);
  }, []);
}
